import { DrawerProvider } from '@/components/Drawer/context/DrawerContext'
import React from 'react'
import GeofenceView from './GeofenceView'
import DrawerContainer from "@/components/Drawer/Drawer";

const Geofence: React.FC = () => {
    return (
        <>
            <DrawerProvider>                
                <GeofenceView />
                <DrawerContainer width='500px' />
            </DrawerProvider>
        </>
    )
}

export default Geofence
